import { Component, effect, inject } from '@angular/core';
import { Router, RouterOutlet } from '@angular/router';
import { environment } from '@env/environment';
import { TenantService } from '@core/tenant/tenant.service';

@Component({
  selector: 'erp-root',
  standalone: true,
  imports: [RouterOutlet],
  template: '<router-outlet />'
})
export class AppComponent {
  private readonly tenantService = inject(TenantService);
  private readonly router = inject(Router);

  constructor() {
    if (environment.brandingTheme === 'erp') {
      document.documentElement.classList.add('theme-erp');
    } else if (environment.brandingTheme === 'c360') {
      document.documentElement.classList.add('theme-c360');
    }

    // Si el subdominio actual no está registrado (404) o suspendido (503),
    // redirige a la pantalla pública. Otros errores (API caída, etc.) no
    // afectan el arranque normal de la app — ver TenantService.cargarContexto.
    effect(() => {
      if (this.tenantService.noDisponible()) {
        this.router.navigateByUrl('/tenant-no-disponible');
      }
    });
  }
}
